<template>
  <div class="main-server">
    <img class="server" src="@/assets/images/503.png" alt="" />
    <h1>服务器维护中</h1>
    <a class="backIndex" href="/">返回首页</a>
  </div>
</template>

<script>
export default {
  name: "503",
  mixins: [],
  props: {},
  model: {},
  components: {},
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.main-server {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .server {
    display: block;
    width: 332px;
    margin: 136px auto 0;
  }
  .backIndex {
    display: block;
    width: 187px;
    height: 40px;
    background: #00afe8;
    border-radius: 4px;
    margin: 44px auto 0;
    font-size: 14px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    &:hover {
      opacity: 0.9;
    }
  }
}
</style>
